import React from 'react'
import Modal from 'react-modal'
import { Input } from 'reactstrap'
import PropTypes from 'prop-types'

const ModalCode = props => (
  <Modal
    isOpen={props.isOpen}
    onRequestClose={props.close}
    contentLabel="Modal"
    ariaHideApp={false}
  >
    <p className="close-modal" onClick={props.close}>
      Close<i className="fa fa-times"></i>
    </p>
    <div className="modal-board">
      <h4>You must verify your mail</h4>
      <p style={{ marginBottom: '10px' }}>
        A code has been sent to your mail, please register it here.
      </p>
      <Input
        onChange={props.change}
        value={props.code}
        placeholder="Enter your code..."
      />
      <br />
      {props.error && <p className="error">{props.error}</p>}
      <div>
        <button className="btn-nissan-red" onClick={props.confirm}>
          Confirm<i className="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </Modal>
)

ModalCode.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired,
  error: PropTypes.string,
}

export default ModalCode
